import { Fragment } from 'react';
import { isNilOrEmpty } from 'ramda-extension';

import { equalOrThreeDashes } from 'utils';
import { joinString } from 'utils/string';

export const generateFullNameOrBusinessName = (businessName, surname, firstName) => {
	return businessName ? businessName : joinString(' ', [surname, firstName]);
};

export const generateProductGroups = (products, raProductGroupsCodelist) => {
	if (!isNilOrEmpty(raProductGroupsCodelist)) {
		const finalProductGroups = products.map((product) => {
			const foundProduct = raProductGroupsCodelist.find((raProduct) => Number(raProduct.id) === product.code);
			const result = foundProduct?.shortDescription;
			return result;
		});

		if (isNilOrEmpty(finalProductGroups)) {
			return equalOrThreeDashes();
		} else {
			return finalProductGroups.map((productGroup, i) => (
				<Fragment key={i}>
					{productGroup}
					<br />
				</Fragment>
			));
		}
	}
};

export const generateStateValue = (state, raStatesCodelist) => {
	const foundState = raStatesCodelist.find((raState) => raState.id === state);
	return foundState?.description;
};

export const generateTypeValue = (type, raTypesCodelist) => {
	const foundType = raTypesCodelist.find((raType) => raType.id === type);
	return foundType?.shortDescription;
};
